import { useContext } from "react";
import {
  Box,
  ColumnLayout,
  Container,
  Select,
  SpaceBetween,
} from "@amzn/awsui-components-react";
import Button from "@amzn/awsui-components-react/polaris/button";
import Input from "@amzn/awsui-components-react/polaris/input";
import { OrderIdContext, StageContext } from "../contexes/OrderIdContext";
import { useSearch } from "../hooks/useSearch";
import { STAGE_OPTIONS } from "../constants";

interface Props {
  children: React.ReactNode;
  setStage: React.Dispatch<React.SetStateAction<string>>;
}

export default function SearchBar({ children, setStage }: Props) {
  const stage = useContext(StageContext) || "prod";

  const {
    orderId,
    orderIdQuery,
    isStageDropdownDisabled,
    selectedOption,
    setOrderIdQuery,
    handleSearch,
    handleStageSelect,
    handleKeyDown,
  } = useSearch(stage, setStage);

  return (
    <OrderIdContext.Provider value={orderId}>
      <SpaceBetween size="xl">
        <Container>
          <ColumnLayout columns={1}>
            <Box padding={{ top: "s", bottom: "s" }}>
              <div className="custom-search-bar">
                <div className="custom-search-bar-input">
                  <Input
                    onChange={({ detail }) =>
                      setOrderIdQuery(detail.value.trim())
                    }
                    value={orderIdQuery}
                    onKeyDown={({ detail }) => handleKeyDown(detail)}
                    type="search"
                    placeholder="Enter Transaction Id (TVOD: Order ID, Subs: AUID)"
                    autoFocus
                  />
                </div>
                <Select
                  className="custom-select"
                  selectedOption={selectedOption}
                  placeholder="Choose an environment"
                  onChange={({ detail }) =>
                    handleStageSelect(detail.selectedOption)
                  }
                  options={STAGE_OPTIONS}
                  disabled={isStageDropdownDisabled}
                  selectedAriaLabel="Selected"
                />
                <div className="custom-search-bar-items">
                  <Button
                    onClick={handleSearch}
                    variant="primary"
                    className="inp"
                  >
                    Search
                  </Button>
                </div>
              </div>
            </Box>
          </ColumnLayout>
        </Container>
        {children}
      </SpaceBetween>
    </OrderIdContext.Provider>
  );
}
